import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from './Button';
import { dialogHeaderFooterBgColor, errorBackgroundColor, warningBackgroundColor } from '../../helpers/colors';


class ConfirmDialog extends PureComponent {
    render() {
        let confirmButton = '';
        let confirmButtonLabel = this.props.confirmLabel || 'Confirm';
        let disabled = this.props.disabled || false;
        if (this.props.confirm && !this.props.confirmButton) {
            confirmButton = (<Button onClick={this.props.confirm} bsStyle="primary" disabled={disabled} icon={this.props.confirmButtonIcon || "ok"} label={confirmButtonLabel}/>);
        }

        if (this.props.confirmButton) {
            confirmButton = this.props.confirmButton;
        }

        let size = this.props.size;
        let dialogClassName;
        if (size === 'full') {
            size = undefined;
            dialogClassName = 'modal-dialog-full';
        }

        if (size === 'fullscreen') {
            size = undefined;
            dialogClassName = 'modal-dialog-fullscreen';
        }

        if (size === 'drawer') {
            size = undefined;
            dialogClassName = 'modal-dialog-drawer';
        }

        if (size === 'welcome') {
            size = undefined;
            dialogClassName = 'modal-dialog-welcome';
        }

        let style = {};
        if (this.props.zIndex) {
            style['zIndex'] = this.props.zIndex;
        }

        let backgroundColor = dialogHeaderFooterBgColor;
        if (this.props.warning) {
            backgroundColor = warningBackgroundColor;
        }

        if (this.props.error) {
            backgroundColor = errorBackgroundColor;
        }

        return (
            <Modal show={this.props.open}
                   onHide={this.props.cancel}
                   bsSize={size}
                   dialogClassName={dialogClassName}
                   style={style}
                   backdrop='static'>
                <Modal.Header style={{ backgroundColor }} closeButton={this.props.cancel !== undefined && !!this.props.cancel}>
                    <Modal.Title data-hj-whitelist>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {this.props.text}
                {this.props.children}
                </Modal.Body>
                {confirmButton && (
                <Modal.Footer style={{ backgroundColor }}>
                {confirmButton}
                </Modal.Footer>)}
            </Modal>
        );
    }
}

ConfirmDialog.propTypes = {
    title: PropTypes.string.isRequired,
    cancel: PropTypes.func,
    confirm: PropTypes.func,
    open: PropTypes.bool.isRequired,
    size: PropTypes.string,
    confirmLabel: PropTypes.string,
    disabled: PropTypes.bool,
    zIndex: PropTypes.number,
    error: PropTypes.string,
};

export default ConfirmDialog;